module.exports = __webpack_public_path__ + "img/cases.bfc64362.svg";